module.exports = __webpack_public_path__ + "media/images/business/illust-cost_cut-e2c195fe082bf366fea7eb75312369f8.svg";